<template>
    <div>
        <!--Subscribe section start-->
        <section :style="{ backgroundImage: 'url(' + backgroundImage + ')' }">
            <modal :delay="100" :clickToClose="false" name="review">
                <div :class="'modal-review ' + language">
                    <img class="review-stars" src="../assets/images/review-stars.png">
                    <div class="review-header">{{translations.reviewHeader}}</div>
                    <div class="review-upsell">{{translations.reviewUpsell}}</div>
                    <div class="review-buttons">
                        <button
                            @click="onAlreadyLeftReview"
                            class="btn btn-custom no-button"
                        >{{translations.noButton}}</button>
                        <button
                            @click="onClickToReview"
                            class="btn btn-custom theme-color yes-button"
                        >{{translations.yesButton}}</button>
                    </div>
                </div>
            </modal>
            <color/>
            <div class="container">
                <div class="row">
                    <div class="col-md-8 offset-md-2">
                        <div class="footer-text">
                            <b-card class="overflow-hidden pod-upsell">
                                <b-row>
                                    <b-col
                                        md="3"
                                        style="align-items: center; justify-content: center; display: flex;"
                                    >
                                        <a
                                            href="https://www.amazon.com/Stoked-Skills-LLC-Puzzle-the/dp/B07ZWMZQM7/"
                                        >
                                            <b-card-img
                                                style="filter: hue-rotate(0deg); height: 100px; width: 100px;"
                                                src="https://m.media-amazon.com/images/I/51wQSMB69dL.png"
                                            ></b-card-img>
                                        </a>
                                    </b-col>
                                    <b-col md="9" style="line-height: 1.2;">
                                        <b-card-text
                                            style="font-size: 30px; display: block; margin-bottom: 10px;"
                                        >Puzzle of the Day</b-card-text>
                                        <b-card-text
                                            style="font-size: 14px  ;"
                                        >Check out our new Alexa daily crossword game! Designed from the ground up for Alexa. Play daily to keep your crossword skills sharp.</b-card-text>
                                        <b-button
                                            style="display: block; background-color: #17a2b8; width: 50%; margin: auto; margin-top: 15px;"
                                            :href="`https://alexa-skills.amazon.com/apis/custom/skills/amzn1.ask.skill.ec157566-b7b7-485f-963f-2c2942154e9a/tasks/PlayPuzzleOfTheDay/versions/1?source=walkthrough-${roomName}`"
                                            variant="info"
                                        >Check it out</b-button>
                                    </b-col>
                                </b-row>
                            </b-card>
                            <h2 class="title text-center md-margin-top">
                                <span>{{roomName}}</span> Walkthrough
                            </h2>
                            <ol class="walkthrough-text">
                                <li :key="step" v-for="step in steps">{{step}}</li>
                            </ol>
                        </div>
                        <div class="footer-review">
                            <img class="review-stars" src="../assets/images/review-stars.png">
                            <div class="review-header">{{translations.reviewHeader}}</div>
                            <div class="review-upsell">{{translations.reviewUpsell}}</div>
                            <div class="review-buttons">
                                <button
                                    @click="onClickToReview"
                                    class="btn btn-custom theme-color yes-button"
                                >{{translations.yesButton}}</button>
                            </div>
                        </div>
                        <LanguageSelector :room="roomKey" :currentLanguage="language"/>
                    </div>
                </div>
            </div>
        </section>
        <!--Subscribe section Ends-->
    </div>
</template>
<script>
export default {
    name: "Walkthrough",
    props: ["roomName", "steps", "backgroundImage", "language", "roomKey"],
    computed: {
        translations() {
            switch (this.language) {
                case "spanish":
                    return {
                        reviewHeader: "Gracias por jugar a Escape the Room",
                        reviewUpsell:
                            "¡Para mantener estas guías gratuitas, dependemos de las reseñas! ¿Podrías dedicar un momento a escribir una reseña rápida? ",
                        yesButton: "Cosa segura",
                        noButton: "Ya he dejado una reseña",
                        reviewUrl:
                            "https://www.amazon.es/product-reviews/B075J914W2"
                    };
                case "german":
                    return {
                        reviewHeader:
                            "Vielen Dank, dass du „Escape Room“ gespielt hast.",
                        reviewUpsell:
                            "Damit diese Komplettlösungen auch weiterhin kostenlos bleiben, sind wir auf eure Bewertungen angewiesen! Würdest du dir bitte einen Moment Zeit nehmen und eine kurze Bewertung hinterlassen? ",
                        yesButton: "Na klar",
                        noButton: "Nicht Jetzt",
                        reviewUrl:
                            "https://www.amazon.de/product-reviews/B075J914W2"
                    };
                case "italian":
                    return {
                        reviewHeader: "Grazie per aver giocato a Escape Room",
                        reviewUpsell:
                            "Per mantenere queste procedure gratuite, ci affidiamo alle recensioni! Ti andrebbe di trovare un minuto per lasciare una recensione veloce? ",
                        yesButton: "Certo",
                        noButton: "Ho già lasciato una recensione",
                        reviewUrl:
                            "https://www.amazon.it/s?k=escape+room+stoked+skills&i=alexa-skills"
                    };
                case "french":
                    return {
                        reviewHeader: "Merci d'avoir joué à Escape Room",
                        reviewUpsell:
                            "Nous avons besoin de ces avis d'examen pour maintenir les passages en revue gratuits ! Pourriez-vous s'il vous plaît, prendre un moment pour donner un avis d'examen rapide ?",
                        yesButton: "Bien sûr",
                        noButton: "J'ai déjà donné mon avis d'examen",
                        reviewUrl:
                            "https://www.amazon.fr/s?k=escape+room+stoked+skills&i=alexa-skills"
                    };
                case "english":
                default:
                    return {
                        reviewHeader: "Thanks for playing Escape the Room.",
                        reviewUpsell:
                            "To keep these walkthroughs free, we rely on reviews! Could you please take a moment to leave a quick review? ",
                        yesButton: "Sure thing",
                        noButton: "I've already left a review",
                        reviewUrl:
                            "https://www.amazon.com/s?k=escape+the+room+stoked+skills&i=alexa-skills"
                    };
            }
        }
    },
    mounted() {
        if (!sessionStorage.getItem("leftReview")) {
            // dont show review for now
            // this.$modal.show("review");
        }
    },
    methods: {
        onAlreadyLeftReview() {
            sessionStorage.setItem("leftReview", new Date());
            this.$modal.hide("review");
        },
        onClickToReview() {
            sessionStorage.setItem("leftReview", new Date());
            window.location = this.translations.reviewUrl;
            this.$modal.hide("review");
        }
    }
};
</script>

<style>
.navbar {
    background: white;
}

@media (max-width: 768px) {
    .v--modal-box {
        height: initial !important;
        max-width: 90vw !important;
        left: 0 !important;
        right: 0 !important;
        margin: auto !important;
    }
    .footer-review button,
    .modal-review button {
        display: block !important;
        margin: 10px auto;
        text-align: center;
    }
    .review-buttons {
        text-align: center;
        display: block !important;
    }
}
</style>

<style scoped>
@keyframes shake {
    0% {
        transform: translate(1px, 1px) rotate(0deg);
    }
    10% {
        transform: translate(-1px, -2px) rotate(-1deg);
    }
    20% {
        transform: translate(-3px, 0px) rotate(1deg);
    }
    30% {
        transform: translate(3px, 2px) rotate(0deg);
    }
    40% {
        transform: translate(1px, -1px) rotate(1deg);
    }
    50% {
        transform: translate(-1px, 2px) rotate(-1deg);
    }
    60% {
        transform: translate(-3px, 1px) rotate(0deg);
    }
    70% {
        transform: translate(3px, 1px) rotate(-1deg);
    }
    80% {
        transform: translate(-1px, -1px) rotate(1deg);
    }
    90% {
        transform: translate(1px, 2px) rotate(0deg);
    }
    100% {
        transform: translate(1px, -2px) rotate(-1deg);
    }
}

.pod-upsell {
    animation: shake;
    animation-duration: 0.5s;
    animation-delay: 10s;
    animation-iteration-count: 1;
}
.walkthrough-text {
    text-align: left;
    color: white;
}

section {
    font-size: 1.3em;
    background-size: cover;
    min-height: 100vh;
}
.title {
    padding-top: 60px;
    color: white;
}

.modal-review {
    padding: 30px;
    text-align: center;
}
.review-stars {
    padding-bottom: 10px;
    width: 80%;
}

.review-buttons {
    display: flex;
    width: 80%;
    margin: auto;
    justify-content: space-evenly;
    margin-top: 15px;
}
.no-button {
    filter: hue-rotate(180deg);
}
.yes-button {
    filter: hue-rotate(320deg);
}
.review-header {
    font-size: 26px;
}
.modal-review.german .review-header {
    font-size: 20px;
}
.modal-review.german .review-upsell {
    font-size: 20px;
    font-size: 13px !important;
}
.pod-upsell {
    margin-top: 60px;
}
.review-upsell {
    margin-top: 20px;
    font-size: 16px !important;
}
.review-upsell img {
    height: 18px;
}
.footer-review {
    margin-top: 40px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 30px;
    padding: 30px;
    text-align: center;
}
.modal-review img {
    padding-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/walkthrough.vue